import {TrueGritSymbol, TrueGritSymbolStates} from "./TrueGritSymbol";
import {TrueGrit} from "../TrueGrit";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {gsap} from "gsap";
import {TrueGritModel} from "../TrueGritModel";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {TrueGritSound} from "../sound/TrueGritSound";

/**
 * Created by Jerker Nord on 2021-11-08.
 */

enum TrueGritGritGirlSymbolSkin {
    dark = "dark",
    gold = "gold",
    normal= "normal"
}
enum TrueGritGritGirlSymbolSplitAnimations {
    split_1_2= "split_1_2",
    split_2_4 = "split_2_4"
}

export class TrueGritGritGirlSymbol extends TrueGritSymbol {

    private _landedInThisRound:boolean = false;
    private _isUsed:boolean = false;
    private _multiplierTextEnabled:PIXI.BitmapText;
    private _multiplierTextDisabled:PIXI.BitmapText;

    private static MULTIPLIER_OFFSET:PIXI.Point = new PIXI.Point(118, 108);
    private _multiplier:number = 1;
    private _splitSpine:PIXI.spine.Spine;

    constructor(symbolName:string) {
        super(symbolName);
        this.createAnimations();
    }

    public getSplitAnimation(newSplitLevel:number):gsap.core.Timeline {
        this.forceSetSplitLevel(newSplitLevel);

        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(()=>{

            if (this.symbolName == "M0"){
                this._splitSpine.skeleton.setSkinByName(TrueGritGritGirlSymbolSkin.dark);
            }
            if (this.symbolName == "M0_2"){
                this._splitSpine.skeleton.setSkinByName(TrueGritGritGirlSymbolSkin.normal);
            }
            if (this.symbolName == "M0_3"){
                this._splitSpine.skeleton.setSkinByName(TrueGritGritGirlSymbolSkin.gold);
            }
            this._splitSpine.visible = true;
            this.currentStateSprite.alpha = 0;
            this.setCurrentStateSpriteTexture();
            this._splitSpine.state.setEmptyAnimation(0,0);
            this._splitSpine.updateTransform();
        });

        if (newSplitLevel == 4){
            tl.add(new SpineTween(this._splitSpine,0, TrueGritGritGirlSymbolSplitAnimations.split_2_4));
        } else {
            tl.add(new SpineTween(this._splitSpine,0, TrueGritGritGirlSymbolSplitAnimations.split_1_2));
        }

        tl.add(this.setMultiplierText(this._multiplier), "<");


        tl.add(()=> {this.currentStateSprite.alpha = 1}, "-=0.05");
        tl.add(()=> {
            this._splitSpine.visible = false;
        })

        return tl;
    }

    private createAnimations():void {
        this._splitSpine = new PIXI.spine.Spine(TrueGrit.assetLoader.getSpineAsset(TrueGritGameAssets.GRETA_SPLIT_SPINE));
        this._splitSpine.position.set(72,72);
        this.addChild(this._splitSpine);


        this._multiplierTextEnabled = new PIXI.BitmapText("x" + TrueGrit.model.initData.botTrain.wildMult, {
            fontName : TrueGritGameAssets.BITMAP_FONT_MULTIPLIER_NUMBERS_ENABLED,
            fontSize : 64
        });
        this._multiplierTextEnabled.anchor = new PIXI.Point(1, 0.5);
        this._multiplierTextEnabled.position = TrueGritGritGirlSymbol.MULTIPLIER_OFFSET;
        this._multiplierTextEnabled.visible = false;
        this.addChild(this._multiplierTextEnabled);

        this._multiplierTextDisabled = new PIXI.BitmapText("x" + TrueGrit.model.initData.botTrain.wildMult, {
            fontName : TrueGritGameAssets.BITMAP_FONT_MULTIPLIER_NUMBERS_DISABLED,
            fontSize : 64
        });
        this._multiplierTextDisabled.anchor = new PIXI.Point(1, 0.5);
        this._multiplierTextDisabled.position = TrueGritGritGirlSymbol.MULTIPLIER_OFFSET;
        this._multiplierTextDisabled.visible = false;
        this.addChild(this._multiplierTextDisabled);




    }

    public playGritGirlLandedAnimation():void {
        if(!this._landedInThisRound) {
            this._landedInThisRound = true;
            const girlsLandedSoFar: number = TrueGrit.trueGritGritGirlSymbols.getGritGirlsLanded();

            if (girlsLandedSoFar === 1) {
                TrueGrit.soundPlayer.playSound(TrueGritSound.GRIT_GIRL_1);
            }

            if (girlsLandedSoFar === 2 && TrueGritModel.canGritGirlChangeState) {
                TrueGrit.soundPlayer.playSound(TrueGritSound.GRIT_GIRL_2);

                TrueGrit.trueGritGritGirlSymbols.play2GirlsLandedAnimation();
            } else if(girlsLandedSoFar > 2) {
                TrueGrit.soundPlayer.playSound(TrueGritSound.GRIT_GIRL_WIN);

                TrueGrit.trueGritGritGirlSymbols.playMoreThan2GirlsLandedAnimation();
            }
        }
    }

    public showEnabledMultiplier():void {
        this._multiplierTextEnabled.visible = true;
        this._multiplierTextDisabled.visible = false;

        // keep their alpha always 1
        this._multiplierTextEnabled.alpha = 1;
        this._multiplierTextDisabled.alpha = 1;
    }

    public showDisabledMultiplier(changeSpeed: number = 0):void {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this._multiplierTextDisabled.visible = true;
            this._multiplierTextDisabled.alpha = 0;
        });
        tl.add([
            gsap.to(this._multiplierTextEnabled, {
                duration: changeSpeed,
                alpha: 0,
                ease: "power2.in"
            }),
            gsap.to(this._multiplierTextDisabled, {
                duration: changeSpeed,
                alpha: 1,
                ease: "power2.out"
            })
        ]);
        tl.add(() => {
            this._multiplierTextEnabled.visible = false;

            // keep their alpha always 1
            this._multiplierTextDisabled.alpha = 1;
            this._multiplierTextEnabled.alpha = 1;
        });
    }

    public reset():void {
        this._landedInThisRound = false;
        if (this._multiplierTextEnabled.visible) {
            this.showDisabledMultiplier(0);
        }
        this.symbolName = "M0";
        this.setCurrentStateSpriteTexture();
        this._isUsed = false;
        this._multiplier = 1;
    }

    public resetState(changeSpeed: number):void {
        if (this._multiplierTextEnabled.visible) {
            this.showDisabledMultiplier(changeSpeed);
        }
        this.symbolName = "M0";
        this.setState(TrueGritSymbolStates.COLLAPSE_LANDING, "", changeSpeed).eventCallback("onComplete", () => {
            this.setCurrentStateSpriteTexture();
        });
    }

    public resetSplitLevel():void {
        this._splitLevel = 0;
    }

    public setMultiplierText(multiplier:number):gsap.core.Timeline {
        this._multiplier = multiplier;
        let splitMultiplier = this.splitLevel > 1 ? this.splitLevel : 1;
        let multiplierText:string = "x" + (this._multiplier * splitMultiplier);

        const tl = gsap.timeline();
        if(multiplierText == this._multiplierTextDisabled.text) {
            return tl;
        }

        tl.add([
            gsap.to(this._multiplierTextEnabled.scale, {duration : 0.1, x : 1.2, y : 1.2}),
        ]);
        tl.add([
            () => {this._multiplierTextEnabled.text = multiplierText},
            () => {this._multiplierTextDisabled.text = multiplierText}
        ]);
        tl.add([
            gsap.to(this._multiplierTextEnabled.scale, {duration : 0.1, x : 1.0, y : 1.0, ease : "back.out(0.7)"}),
        ]);

        return tl;
    }

    get isUsed():boolean {
        return this._isUsed;
    }

    set isUsed(value:boolean) {
        this._isUsed = value;
    }

    get landedInThisRound():boolean {
        return this._landedInThisRound;
    }

    set landedInThisRound(value: boolean) {
        this._landedInThisRound = value;
    }
}